import { generatePath, matchPath } from 'react-router-dom';
import PATHS from '../../../routes/routes.const';
import { EntityType } from '../types/sharedEntities.enum';

const PUBLIC_SHARE_PATHS = [PATHS.public.catalog.path, PATHS.public.order.path];

const INTERNAL_PATH_BY_ENTITY: Record<EntityType, string> = {
  [EntityType.Catalog]: PATHS.main.catalogs.products.path,
  [EntityType.Order]: PATHS.main.orders.suggestion.path,
};

export const getSharedPublicId = (url: string): string | undefined => {
  const pathname = url.split(/[#?]/)[0];

  const match = PUBLIC_SHARE_PATHS.map((path) =>
    matchPath<{ id: string }>(pathname, { path, exact: true }),
  ).find((result) => !!result);

  return match?.params.id;
};

export const getSharedEntityInternalPath = (entity: EntityType, entityId: string): string =>
  generatePath(INTERNAL_PATH_BY_ENTITY[entity], { id: entityId });
